import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { CollaborativeBillSplitItemResponseDto } from '@features/client/models/public-bill-split-collaboration-models';
import {
  EqualShareScope,
  ParticipantItemSelectionDraft,
} from '@features/client/models/participant-selection.models';

@Component({
  selector: 'app-participant-item-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './participant-item-card.html',
})
export class ParticipantItemCardComponent {
  item = input.required<CollaborativeBillSplitItemResponseDto>();
  draft = input.required<ParticipantItemSelectionDraft>();

  toggleSelected = output<void>();
  modeChange = output<'EQUAL_SHARE' | 'BY_QUANTITY'>();
  equalShareScopeChange = output<EqualShareScope>();
  equalShareQuantityChange = output<number>();
  quantityChange = output<number>();
  unresolvedClick = output<void>();

  readonly maxPartialEqualShare = computed(() => Math.max(1, (this.item().quantity ?? 1) - 1));

  decrementEqualShareQuantity(): void {
    const current = this.draft().equalShareQuantity ?? 1;
    const next = Math.max(1, current - 1);
    this.equalShareQuantityChange.emit(next);
  }

  incrementEqualShareQuantity(): void {
    const current = this.draft().equalShareQuantity ?? 1;
    const next = Math.min(this.maxPartialEqualShare(), current + 1);
    this.equalShareQuantityChange.emit(next);
  }

  decrementQuantity(): void {
    const current = this.draft().quantity ?? 1;
    const next = Math.max(1, current - 1);
    this.quantityChange.emit(next);
  }

  incrementQuantity(): void {
    const current = this.draft().quantity ?? 1;
    const next = Math.min(this.item().quantity, current + 1);
    this.quantityChange.emit(next);
  }
}
